function GamepadButtonEvent (type, index, details) {
  this.type = type;
  this.index = index;
  this.pressed = details.pressed;
  this.value = details.value;
}

module.exports = GamepadButtonEvent;



//////////////////
// WEBPACK FOOTER
// ./~/aframe-extras/lib/GamepadButtonEvent.js
// module id = 242
// module chunks = 0